import { Star, StarHalf } from "lucide-react";

export const Rating = ({ value, count, size = 14 }) => {
  const full = Math.floor(value);
  const half = value - full >= 0.4;
  return (
    <div className="flex items-center gap-1.5" data-testid="product-rating">
      <div className="flex text-amber-500">
        {[...Array(5)].map((_, i) => {
          if (i < full) return <Star key={i} size={size} fill="currentColor" strokeWidth={0} />;
          if (i === full && half) return <StarHalf key={i} size={size} fill="currentColor" strokeWidth={0} />;
          return <Star key={i} size={size} className="text-slate-300" fill="currentColor" strokeWidth={0} />;
        })}
      </div>
      <span className="text-xs font-medium text-slate-600">{value.toFixed(1)}</span>
      {count != null && <span className="text-xs text-slate-400">({count.toLocaleString()})</span>}
    </div>
  );
};
